import * as React from 'react';
import * as styles from './styles.css';

import { getUnits } from './utils';
import { Star } from './Star';

export interface IStarsProps {
  uniqueKey: string;
  value: number;
}

const STARS_COUNT = 5;

export function Stars({ uniqueKey, value }: IStarsProps) {
  const units = getUnits(STARS_COUNT, value);

  return (
    <ul className={styles['container']}>
      {units.map((value, index) => {
        const key = `${uniqueKey}-${index}`;

        return (
          <li key={key}>
            <Star gradientId={key} value={value} />
          </li>
        );
      })}
    </ul>
  );
}
